/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Entitycount1Inputs */

const en_entity_entitycount1 = /** @type {(inputs: Entity_Entitycount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity Count`)
};

const de_entity_entitycount1 = /** @type {(inputs: Entity_Entitycount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitätenanzahl`)
};

/**
* | output |
* | --- |
* | "Entity Count" |
*
* @param {Entity_Entitycount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_entitycount1 = /** @type {((inputs?: Entity_Entitycount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Entitycount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_entitycount1(inputs)
	return de_entity_entitycount1(inputs)
});
export { entity_entitycount1 as "entity_entityCount" }